import Text from "../../../Components/Text/Text";
import HeroImage from "../../../assets/images/blockchain-hero.png";
import { ReactComponent as RightTriangleSvg } from "../../../assets/svgs/right-triangle.svg";

export default function IntroductionSection() {
  return (
    <section
      className={`w-full h-screen bg-cover bg-left sm:bg-bottom bg-no-repeat bg-[url('./assets/images/mobile-application-hero-bg.png')]`}
    >
      <div className="container mx-auto h-full px-4 grid place-items-center sm:grid-cols-2 animate-fade-in-left">
        <div>
          <Text type="h1" size="xl" className="font-bold">
          Blockchain Development
          </Text>

          <Text
            type="h2"
            size="lg"
            className="font-semibold max-w-lg xl:max-w-3xl mt-8"
          >
            Blockchain for Your Business
          </Text>

          <Text type="p" className="my-10 max-w-lg xl:max-w-3xl">
          Use blockchain to streamline operations, payments and create new
            opportunities.
          </Text>
        </div>
        <div>
          <img src={HeroImage} alt="Mobile application" />
        </div>
      </div>

      <RightTriangleSvg className="transition-all absolute bottom-0 fill-[#F4F4F4] animate-raise-up w-full" />
    </section>
  );
}
